class GridOptions extends HTMLElement {
    constructor() {
      super();
      this.gridOptions = this;
      this.productGrid = document.getElementById("product-grid");
      this.grid = this.getViewFromCookie();
      this.smallGrid = this.getSmallViewFromCookie();
  
      if (this.productGrid) this.gridOptions.addEventListener('click', this.selectGrid.bind(this));
      if (this.grid == null) this.grid = "4"
      this.productGrid.dataset.grid = this.grid;
      this.querySelector(".grid-options--large.active")?.classList.remove("active");
      this.querySelector(`.grid-options--large[data-grid="${this.grid}"`)?.classList.add("active");
      
      if (this.smallGrid == null) this.smallGrid = "2"
      this.productGrid.dataset.smallGrid = this.smallGrid;
      this.querySelector(".grid-options--small.active")?.classList.remove("active");
      this.querySelector(`.grid-options--small[data-grid="${this.smallGrid}"`)?.classList.add("active");
    }

    setViewCookie(view) {
      document.cookie = `selectedView=${view}; path=/`;
    }

    setViewSmallCookie(view) {
      document.cookie = `selectedSmallView=${view}; path=/`;
    }

    getViewFromCookie() {
      const name = "selectedView=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookies = decodedCookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
      return null;
    }

    getSmallViewFromCookie() {
      const name = "selectedSmallView=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookies = decodedCookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
      return null;
    }
  
    selectGrid(event) {
      let eventTarget = event.target;
      if (eventTarget.tagName.toLowerCase() == "svg" || eventTarget.tagName.toLowerCase() == "path") {
        eventTarget = eventTarget.closest("button");
      }
      if (eventTarget.tagName.toLowerCase() == "button") {
        if (eventTarget.classList.contains("grid-options--large")) {
          this.productGrid.dataset.grid = eventTarget.dataset.grid;
          eventTarget.parentNode.querySelector(".active")?.classList.remove("active");
          eventTarget.classList.add("active");
          this.setViewCookie(this.productGrid.dataset.grid);
        } else {
          this.productGrid.dataset.smallGrid = eventTarget.dataset.grid;
          eventTarget.parentNode.querySelector(".active")?.classList.remove("active");
          eventTarget.classList.add("active");
          this.setViewSmallCookie(this.productGrid.dataset.smallGrid);
        }
        
        window.scrollTo({ top: 0 });
      }
    }
  }
  

  customElements.define('grid-options', GridOptions);